module.exports = __webpack_public_path__ + "static/media/leader_notes.3d0cd23a.pdf";